import { isValidApiBaseProps } from '@common/api.services';
import { FETCH_QUERIES_NAME } from '@common/constants';
import { isPositiveNumber } from '@core/Primitives/number.services';
import { useQuery } from '@tanstack/react-query';

import {
  getAllTransmittalPurposeOptionsAsync,
  getTransmittalPurposeOptionsAsync,
  IGetAllTransmittalPurposeOptionsAsyncProps,
  IGetTransmittalPurposeOptionsAsyncProps,
} from './transmittalPurpose.services';

export const useGetTransmittalPurposeOption = (props: IGetTransmittalPurposeOptionsAsyncProps) => {
  return useQuery(
    [
      props.projectId,
      props.masterScheduleId,
      FETCH_QUERIES_NAME.TRANSMITTAL_PURPOSE_OPTIONS,
      props.transmittalId,
      props.transmittalType,
    ],
    async () => {
      const results = await getTransmittalPurposeOptionsAsync(props);
      return results.items || [];
    },
    {
      enabled:
        isPositiveNumber(props.masterScheduleId) &&
        isValidApiBaseProps(props) &&
        !!props.transmittalId &&
        !!props.transmittalType,
    },
  );
};

export const useGetAllTransmittalPurposeOption = (props: IGetAllTransmittalPurposeOptionsAsyncProps) => {
  return useQuery(
    [props.projectId, props.masterScheduleId, FETCH_QUERIES_NAME.TRANSMITTAL_PURPOSE_OPTIONS, props.transmittalType],
    async () => {
      const results = await getAllTransmittalPurposeOptionsAsync(props);
      return results.items || [];
    },
    {
      enabled: isPositiveNumber(props.masterScheduleId) && isValidApiBaseProps(props) && !!props.transmittalType,
    },
  );
};
